import { render } from "./Layout.vue?vue&type=template&id=06233730&scoped=true&ts=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"

import "./Layout.vue?vue&type=style&index=0&id=06233730&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/miyo-prod/ftrc-prd/src/project/fotile-riskctl/code/frontend/mgr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06233730"]])

export default __exports__